import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import ReviewPage from "./ReviewPage";

function MobileConciergeServices() {
  return (
    <>
      <div id="mobile-concierge-services"></div>
      <Header />
      <section className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "3rem",
                letterSpacing: "3.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              Mobile Concierge
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis pt-0 mt-0 ">
                  Get a Mobile Concierge Services at Rapid Lab Diagnostics
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  Mobile concierge lab services provide a convenient and
                  personalized way to access laboratory testing and diagnostic
                  care without leaving your home or workplace. Instead of
                  traveling to a clinic or hospital, trained professionals come
                  directly to your location, fully equipped to perform a wide
                  range of services, including routine blood work, specialized
                  testing, and certain diagnostic procedures. This approach is
                  especially beneficial for busy individuals, elderly patients,
                  or those with mobility challenges. Our mobile concierge team
                  is committed to delivering the same high standards of accuracy
                  and professionalism you would expect in a traditional medical
                  setting. Every procedure is carried out with strict attention
                  to safety, hygiene, and patient comfort. By eliminating travel
                  time and long waiting periods, our service allows you to focus
                  on your health while enjoying a stress-free experience in a
                  familiar environment. In addition to convenience, we
                  prioritize timely and reliable results, ensuring that you and
                  your healthcare provider receive the information needed for
                  proper diagnosis and treatment. From scheduling your
                  appointment to completing your tests, our team works closely
                  with you to make the process smooth and efficient.
                </p>

                <p className="text-primary-emphasis">
                  {" "}
                  If you have any questions or concerns about our mobile
                  concierge services, our dedicated support team is always
                  available to guide you, provide information, and assist you at
                  every step of your healthcare journey. Contact us today to
                  schedule your mobile lab appointment and experience the
                  convenience and quality of care that we offer right at your
                  doorstep.
                </p>
              </div>
              {/* Right Images */}
              <div className="col-lg-6 text-center pt-3">
                <img
                  src="images/assets/mobile-concierge.jpeg"
                  alt="mobile"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "550px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    src="images/assets/lady-lab-tech.png"
                    alt="lab1"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "230px",
                      height: "230px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/x-ray.png"
                    alt="x-ray"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "230px",
                      height: "230px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/ultraSound.jpeg"
                    alt="lab3"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "230px",
                      height: "230px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* put  CARD HERE */}
            <div
              className="card mb-3 mt-3 pt-md-2 shadow-sm rounded"
              style={{ maxWidth: "500px", borderTop: "4px solid #FFD700" }}
            >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-primary-emphasis fw-semibold">
                      How it Works
                    </h5>
                    <p className="card-text col-12">
                      Our mobile concierge service offers a simple and
                      convenient healthcare experience. You can schedule an
                      appointment easily, and a trained professional will visit
                      your location to perform the tests in a safe and
                      comfortable setting. Samples are then sent to the lab for
                      analysis, with accurate results delivered promptly to you
                      and your healthcare provider.
                    </p>
                    <p className="card-text col-12"></p>
                  </div>
                </div>
              </div>
            </div>
            {/* Banner */}
            <div className="container my-5">
              <div
                className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
                style={{
                  backgroundColor: "#0f5b7f",
                  borderRadius: "12px",
                }}
              >
                {/* Left Text */}
                <h2
                  className="text-white mb-4 mb-md-0"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    maxWidth: "700px",
                    lineHeight: "1.4",
                  }}
                >
                  Visit Us for Your Laboratory Needs and Experience the
                  Difference in Care and Quality
                </h2>

                {/* Right Button */}
                <Link
                  className="link-underline link-underline-opacity-0 text-decoration-none"
                  to="https://www.google.com/maps/place/Rapid+Lab+and+Diagnostics+center/@5.6747617,-0.0208036,21z/data=!4m6!3m5!1s0xfdf813ca0f57087:0xef5fd0638781ba41!8m2!3d5.6748397!4d-0.0208213!16s%2Fg%2F11t6hmrfy0?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                >
                  <button
                    className="btn text-white d-flex align-items-center gap-2"
                    style={{
                      border: "2px solid white",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    LOCATION
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-caret-right-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reasons for a Mobile Concierge Service with Rapid Lab
                  Diagnostics
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>
                <p className="text-primary-emphasis">
                  Rapid Lab Diagnostics’ mobile concierge service provides a
                  convenient and hassle-free way to receive testing at your
                  location. A trained professional performs the tests safely,
                  and samples are analyzed with accurate results delivered
                  quickly to you and your healthcare provider.
                </p>
                <p className="text-primary-emphasis">
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}The mobile concierge service eliminates the need
                        for travel and waiting rooms, providing a more
                        convenient and comfortable experience for patients.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        It is ideal for individuals with mobility issues, busy
                        schedules, or those who prefer the convenience of
                        at-home testing.
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        The service provides timely and accurate results,
                        ensuring that patients and healthcare providers have the
                        information needed for proper diagnosis and treatment
                        without delay.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Rapid Lab Diagnostics’ mobile concierge service makes
                        accessing essential lab services easy and convenient
                        from your home or workplace.
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  If you are seeking mobile concierge services, Rapid Lab
                  Diagnostics offers a convenient and reliable solution for your
                  laboratory needs. Contact us today to schedule your
                  appointment and experience the difference in care and quality
                  that we provide right at your doorstep.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/medlab-lady-2.png.png"
                  alt="exercise"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            {/* Reviews */}

            <div className="container text-center py-5 bg-muted    ">
              <ReviewPage />
              <div className="row align-items-center g-4 py-5 mt-5">
                <div className="col-lg-6 text-center">
                  <img
                    src="images/assets/medlab-lady-1.png"
                    alt="rapidLabEnterance"
                    loading="lazy"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "500px",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bold text-primary-emphasis text-start ">
                    Choose Rapid Lab Diagnostics for Your Mobile Concierge
                    Services and Experience the Difference in Care and Quality
                  </h2>

                  <div
                    className="my-3 "
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>

                  <p className="text-primary-emphasis text-start">
                    With Rapid Lab Diagnostics, you can trust that your mobile
                    concierge services will be delivered with the highest
                    standards of care, accuracy, and professionalism. Our team
                    is dedicated to providing a seamless and convenient
                    healthcare experience, ensuring that you receive the
                    essential laboratory services you need without leaving your
                    home or workplace. Contact us today to schedule your
                    appointment and discover the benefits of our mobile
                    concierge services for yourself.
                  </p>
                </div>
              </div>

              {/* F&Q */}
              <div>
                <p className="fs-3 text-primary-emphasis">
                  Mobile Concierge Frequently Asked Questions
                  <div
                    className="my-1 m-auto"
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>
                </p>
              </div>
              {/* Accordion */}
              <div
                className="accordion  col-10  m-auto my-5"
                id="accordionFlushExample "
                style={{ borderTop: "4px solid #FFD700", borderRadius: "8px" }}
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                      style={{ borderRadius: "8px" }}
                    >
                      What happens during an Mobile Concierge Service?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      During a mobile concierge service, a trained healthcare
                      professional will visit your location, whether it’s your
                      home or workplace, to perform the necessary laboratory
                      tests. The professional will bring all the required
                      equipment and supplies to safely and accurately collect
                      samples, such as blood or urine, or perform certain
                      diagnostic procedures. The process is designed to be
                      convenient and comfortable for you, eliminating the need
                      for travel and waiting rooms. After the samples are
                      collected, they are sent to the lab for analysis, and the
                      results are delivered promptly to you and your healthcare
                      provider for review and appropriate follow-up care.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                      style={{ borderRadius: "8px" }}
                    >
                      How should I prepare for Mobile Concierge Service?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      No special preparation is needed for a mobile concierge
                      service. You can go about your day as usual, and the
                      healthcare professional will arrive at your scheduled time
                      with all the necessary equipment.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                      style={{ borderRadius: "8px" }}
                    >
                      Is Mobile Concierge Service safe?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Mobile concierge services are designed to be safe and
                      comfortable for patients. The healthcare professionals who
                      provide these services are trained to follow strict safety
                      and hygiene protocols to ensure that all procedures are
                      carried out in a safe manner. Additionally, many of the
                      tests and procedures performed during a mobile concierge
                      service are non-invasive and low-risk, making it a
                      convenient and secure option for patients who may have
                      mobility issues or prefer the convenience of at-home
                      testing.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default MobileConciergeServices;
